import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Field } from '../types/fields';

@Component({
  selector: 'app-field-type-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <div [class]="containerClass()">
      @switch (type()) {
        @case ('string') {
          <mat-icon class="!text-lg !w-[18px] !h-[18px] !leading-[18px] text-blue-500">text_fields</mat-icon>
        }
        @case ('number') {
          <mat-icon class="!text-lg !w-[18px] !h-[18px] !leading-[18px] text-green-500">tag</mat-icon>
        }
        @case ('boolean') {
          <mat-icon class="!text-lg !w-[18px] !h-[18px] !leading-[18px] text-purple-500">toggle_on</mat-icon>
        }
        @case ('string-list') {
          <mat-icon class="!text-lg !w-[18px] !h-[18px] !leading-[18px] text-orange-500">list</mat-icon>
        }
        @case ('number-list') {
          <mat-icon class="!text-lg !w-[18px] !h-[18px] !leading-[18px] text-teal-500">format_list_numbered</mat-icon>
        }
        @case ('object') {
          <mat-icon class="!text-lg !w-[18px] !h-[18px] !leading-[18px] text-amber-500">data_object</mat-icon>
        }
        @case ('object-list') {
          <mat-icon class="!text-lg !w-[18px] !h-[18px] !leading-[18px] text-rose-500">data_array</mat-icon>
        }
        @default {
          <mat-icon class="!text-lg !w-[18px] !h-[18px] !leading-[18px] text-zinc-400 dark:text-zinc-500">help_outline</mat-icon>
        }
      }
    </div>
  `
})
export class FieldTypeIconComponent {
  type = input<Field['type'] | string>();
  size = input<'md' | 'sm'>('md');

  containerClass = computed(() => {
    const base = 'flex items-center justify-center shrink-0';
    if (this.size() === 'sm') {
      return `${base} h-5 w-5`;
    }
    return `${base} h-9 w-9 rounded-lg bg-zinc-50 dark:bg-zinc-700 border border-zinc-100 dark:border-zinc-600`;
  });
}
